"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureAppTheme = exports.createThemeConfigure = exports.MediaQuery = exports.AppThemeContext = exports.useAppTheme = void 0;
var React = __importStar(require("react"));
var defaultAppTheme = {
    buttonGroup: {
        wrapper: {},
        item: {},
        itemActive: {},
        icon: {},
        iconActive: {},
        label: {},
        labelActive: {},
    },
    pdfViewer: {
        pageSelectorWrapper: {},
        pageSelector: {},
        pageNumber: {},
        pdfWrapper: {},
        downloadButton: {},
        closeButton: {},
    },
    table: {
        tableWrapper: {},
        listWrapper: {},
        rowWrapper: {},
        rowCell: {},
        rowText: {},
        headerWrapper: {},
        headerCell: {},
        headerText: {},
        loadingWrapper: {},
        noResultsWrapper: {},
        noResultsLabel: {},
        loading: {},
        headerOuterWrapper: {},
        descriptionOuterWrapper: {},
        descriptionIcon: {},
        descriptionIconWrapper: {},
        descriptionPopup: {},
        descriptionText: {}
    },
    fileInput: {
        wrapper: {},
    },
    multiFileInput: {
        wrapper: {},
    },
    modal: {
        outerWrapper: {},
        innerWrapper: {},
    },
    popoverDropdown: {
        button: {},
        burgerMenuButton: {},
        label: {},
        icon: {},
    },
    popoverWithItems: {
        itemLabel: {},
        popover: {},
        wrapper: {},
        item: {},
    },
    html: {
        a: {},
        p: {},
        h1: {},
        h2: {},
        h3: {},
        h4: {},
        h5: {},
        h6: {},
        button: {},
        li: {},
        option: {},
    },
    button: {
        chromeless: {},
        primary: {},
        label: {},
        primaryLabel: {},
        secondaryLabel: {},
        chromelessLabel: {},
        secondary: {},
        common: {},
        spinner: {},
    },
    label: {
        descriptionIcon: {},
        descriptionIconWrapper: {},
        descriptionPopup: {},
        descriptionText: {},
        errorIcon: {},
        errorLabel: {},
        labelText: {},
        labelTextError: {},
        labelTextWrapper: {},
        sublabelText: {},
        wrapper: {},
    },
    textInput: {
        disabledInput: {},
        disabledWrapper: {},
        errorHook: {},
        errorInput: {},
        errorWrapper: {},
        hook: {},
        input: {},
        prefix: {},
        postfix: {},
        readOnlyHook: {},
        readOnlyInput: {},
        readOnlyWrapper: {},
        wrapper: {},
    },
    textArea: {
        disabled: {},
        input: {},
        wrapper: {},
    },
    staticChecklist: {
        description: {},
        iconAllowed: {},
        iconDisallowed: {},
        item: {},
        itemIcon: {},
        itemLabel: {},
        itemsList: {},
        list: {},
        listsWrapper: {},
        title: {},
        wrapper: {},
    },
    slider: {
        label: {},
        prefix: {},
        value: {},
        valueWrapper: {},
        wrapper: {},
        outerWrapper: {},
    },
    materialSlider: {
        active: {},
        root: {},
        rail: {},
        mark: {},
        markActive: {},
        markLabel: {},
        valueLabel: {},
        thumb: {},
        track: {},
    },
    select: {
        option: {},
        wrapper: {},
        errorWrapper: {},
        icon: {},
        select: {},
    },
    colorPicker: {
        circle: {},
        labelModal: {},
        labelColor: {},
        wrapper: {},
    },
    datePicker: {
        disabledInput: {},
        errorHook: {},
        errorInput: {},
        errorWrapper: {},
        hook1: {},
        hook2: {},
        iconWrapper: {},
        inputWrapper: {},
        reactDatePicker: '',
        wrapper: {},
    },
    dropdown: {
        wrapper: {},
    },
    optionGroup: {
        wrapper: {},
        item: {},
        itemActive: {},
        label: {},
        labelActive: {},
        errorWrapper: {},
    },
    toggle: {
        wrapper: {},
        wrapperActive: {},
        circle: {},
        circleActive: {},
    },
    radioGroup: {
        wrapper: {},
        label: {},
        item: {},
        radioOuter: {},
        radioOuterActive: {},
        radioInner: {},
        radioInnerActive: {},
        radioOuterError: {},
        errorWrapper: {},
    },
    singleCheckbox: {
        wrapper: {},
        input: {},
    },
    codeInput: {
        wrapper: {},
        input: {},
    },
    icon: {
        edit: {},
        info: {},
        settings: {},
    },
    navigation: {
        carrot: {},
        item: {},
        itemActive: {},
        itemCircle: {},
        itemCircleActive: {},
        itemLabel: {},
        itemLabelActive: {},
        itemNumber: {},
        itemWrapper: {},
        wrapperInner: {},
        wrapperOuter: {},
    },
    uploadDropzone: {
        container: {},
        dropzoneLabel: {},
        dropzoneSublabel: {},
        acceptedFilesLabel: {},
        rejectedFilesLabel: {},
        acceptedFileItem: {},
        rejectedFileItem: {},
        errorMessage: {},
        section: {},
        sectionSingleItem: {},
        imageItem: {},
        listItem: {},
        listSingleItem: {},
        removeItemIcon: {},
    },
};
exports.useAppTheme = function () {
    var theme = React.useContext(exports.AppThemeContext);
    if (!theme) {
        throw new Error("AppTheme not found");
    }
    return theme;
};
exports.AppThemeContext = React.createContext(undefined);
exports.AppThemeContext.displayName = 'AppThemeContext';
var MediaQuery;
(function (MediaQuery) {
    MediaQuery["Mobile"] = "(max-width: 768px)";
    MediaQuery["Small"] = "(max-width: 840px)";
})(MediaQuery = exports.MediaQuery || (exports.MediaQuery = {}));
exports.createThemeConfigure = function (defaultTheme) {
    return function (userTheme) {
        return Object.keys(defaultTheme).reduce(function (components, componentKey) {
            var _a;
            return (__assign(__assign({}, components), (_a = {}, _a[componentKey] = Object.keys(defaultTheme[componentKey]).reduce(function (componentStyles, styleKey) {
                var _a;
                var _b;
                var isCSSStyles = typeof defaultTheme[componentKey][styleKey] === 'string';
                var userThemeVal = ((_b = userTheme[componentKey]) === null || _b === void 0 ? void 0 : _b[styleKey]) || (isCSSStyles && '') || {};
                return __assign(__assign({}, componentStyles), (_a = {}, _a[styleKey] = isCSSStyles
                    ? userThemeVal
                    : __assign(__assign({}, defaultTheme[componentKey][styleKey]), userThemeVal), _a));
            }, {}), _a)));
        }, {});
    };
};
exports.configureAppTheme = exports.createThemeConfigure(defaultAppTheme);
//# sourceMappingURL=theme.js.map